module.exports = __webpack_public_path__ + "static/media/ozow_logo_vector_small.76d41330.png";